import userServiceApi from "../api/userServiceApi";
import { getRequest, postRequest } from "../api/http";

export const STRIPE_ONBOARDING_COMPLETE_KEY = "stripeOnboardingComplete";

export const isStripeOnboardingPending = () =>
  sessionStorage.getItem(STRIPE_ONBOARDING_COMPLETE_KEY) === "false";

/** Same account-details API as login; updates session flag from `onboardingComplete`. */
export const fetchAccountOnboardingComplete = async (connectedAccountId) => {
  if (!connectedAccountId) {
    setStripeOnboardingSessionFlag(false);
    return false;
  }
  /*for stripe flow please  enable below commented code  */

  try {
    const accountDetailsResponse = await getRequest(
      userServiceApi.getStripeOnboardingStatus(connectedAccountId)
    );
    // const onboardingComplete =
    //   accountDetailsResponse?.data?.onboardingComplete === true;
    // setStripeOnboardingSessionFlag(onboardingComplete);
    const onboardingComplete = true
    return onboardingComplete;
  } catch (error) {
    console.log("Stripe onboarding status error----->", error);
    return sessionStorage.getItem(STRIPE_ONBOARDING_COMPLETE_KEY) === "true";
  }
};

/*for stripe flow please  enable below commented code  */

export const setStripeOnboardingSessionFlag = (onboardingComplete) => {
  sessionStorage.setItem(
    STRIPE_ONBOARDING_COMPLETE_KEY,
    // onboardingComplete ? "true" : "false"
    onboardingComplete ? "true" : "true"

  );
};

export const isStripeConnectOnboardingUrl = (url) =>
  typeof url === "string" && url.includes("connect.stripe.com");

export const isStripeExpressRedirectUrl = (url) =>
  typeof url === "string" &&
  (url.includes("connect.stripe.com") || url.includes("dashboard.stripe.com"));

export const getStripeRedirectUrl = (stripeResponse) => {
  if (!stripeResponse) return "";
  if (typeof stripeResponse === "string") {
    return isStripeExpressRedirectUrl(stripeResponse) ? stripeResponse : "";
  }

  const candidates = [
    stripeResponse?.accountUrl,
    stripeResponse?.data?.accountUrl,
    stripeResponse?.url,
    stripeResponse?.data?.url,
    stripeResponse?.loginUrl,
    stripeResponse?.data?.loginUrl,
    typeof stripeResponse?.data === "string" ? stripeResponse.data : "",
  ];

  return candidates.find((url) => isStripeExpressRedirectUrl(url)) || "";
};

export const getStripeAccountUrl = (stripeResponse) => {
  if (!stripeResponse) return "";
  if (typeof stripeResponse === "string") {
    return isStripeConnectOnboardingUrl(stripeResponse) ? stripeResponse : "";
  }

  const candidates = [
    stripeResponse?.accountUrl,
    stripeResponse?.data?.accountUrl,
    stripeResponse?.url,
    stripeResponse?.data?.url,
    typeof stripeResponse?.data === "string" ? stripeResponse.data : "",
  ];

  return candidates.find((url) => isStripeConnectOnboardingUrl(url)) || "";
};

export const fetchAndStoreStripeOnboardingUrl = async (accountId) => {
  if (!accountId) return;

  try {
    const stripeResponse = await postRequest(
      userServiceApi.getStripeLink(accountId)
    );
    const url = getStripeAccountUrl(stripeResponse);
    if (url) {
      sessionStorage.setItem("stripeOnboardingUrl", url);
    }
  } catch (error) {
    console.log("Stripe onboarding link error----->", error);
  }
};

